module.exports = __webpack_public_path__ + "img/37.dab53c1c.png";